import styled from "styled-components";
import { minMedium, shade950 } from "@songtradr-one/components-frontend";
import { staticText } from "../../../../../shared/statics/static-text";

// TEXT
export const text = staticText.appHeader.userMenu;

// STYLES
// Not a ListItem: stays out of the dropdown's roving focus.
export const StaticItem = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1.5rem;
  background-color: ${shade950};
  cursor: default;

  @media ${minMedium} {
    gap: 1rem;
    padding: 0.75rem 1rem 0.75rem 1.5rem;
  }
`;

// DATA

// TYPES
export type Props = {
  firstName?: string;
  lastName?: string;
  email?: string;
};

// CONSTANTS

// FUNCTIONS

// ASSETS
